// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React from 'react';
import styled from 'styled-components';
import Column from './Column';

type Direction = 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight';

interface TriangleProps {
  direction: Direction;
  offset: number;
}

const Triangle = styled.div<TriangleProps>`
  ${({ direction, offset }) => {
    if (direction === 'topLeft' || direction === 'bottomLeft') {
      return `
        align-self: flex-start;
        margin-left: ${offset}px;
      `
    } else {
      return `
        align-self: flex-end;
        margin-right: ${offset}px;
      `
    }
  }}

  ${({ direction }) => {
    if (direction === 'topLeft' || direction === 'topRight') {
      return `
        border-width: 0 5px 5px 5px;
        border-color: transparent transparent #FFFFFF transparent;
      `
    } else {
      return `
        border-width: 5px 5px 0 5px;
        border-color: #FFFFFF transparent transparent transparent;
      `
    }
  }}

  border-style: solid;
  z-index: 1;
`

interface Props {
  direction: Direction;
}

const Card = styled.div`
  border-radius: 3px;
  background: #FFFFFF;
  box-shadow: 0px 3px 20px #0000004D;
`

export default styled(({ children, direction, ...props }: Props & React.ComponentPropsWithoutRef<any>) => {
  return (
    <Column {...props}>
      {direction === 'topLeft' || direction === 'topRight' ? <Triangle direction={direction} offset={18} />: null}
      <Card>{children}</Card>
      {direction === 'bottomLeft' || direction === 'bottomRight' ? <Triangle direction={direction} offset={44} />: null}
    </Column>
  )
})`
  ${({ direction }) => direction === 'topLeft' || direction === 'bottomLeft'? { left: '0' }: { right: '0' }}
`
